module.exports = __webpack_public_path__ + "img/commercial.daac18d5.jpg";